import React from "react"

import Header from "./header"
import { rhythm } from "../utils/typography"

const BlogLayout = ({ title, children }) => {
  return (
    <>
      <Header siteTitle={title} />
      <div
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
          maxWidth: rhythm(24),
          padding: `${rhythm(0.5)} ${rhythm(3 / 4)}`,
        }}
      >
        <main>{children}</main>
        <footer style={{ margin: `3rem auto 0 auto` }}>
          <small>© {new Date().getFullYear()} Adam Smyer</small>
        </footer>
      </div>
    </>
  )
}

export default BlogLayout
